import i18n, { InitOptions } from 'i18next';
import { initReactI18next } from 'react-i18next';

import Backend from 'i18next-xhr-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import moment from 'moment';
// import 'moment/locale/ru'; // As new languages are added they must be imported for moment.js

/** Keep in sync with namespaces loaded from /locales (and with __mocks__/i18nextMock when used). */
const NAMESPACES = ['controlCenter', 'validation', 'tos', 'common', 'marketing', 'masterData', 'myOrganization', 'myProfile', 'editUser'] as const;

const reactOptions: InitOptions['react'] = {
    useSuspense: false,
    transEmptyNodeValue: '',
    bindI18n: 'languageChanged loaded',
    bindI18nStore: 'added removed',
    nsMode: 'default',
};

function emptyEnglishResources(): NonNullable<InitOptions['resources']> {
    const en: Record<string, Record<string, unknown>> = {};
    for (const ns of NAMESPACES) {
        en[ns] = {};
    }
    return { en };
}

const prodOptions: InitOptions = {
    interpolation: { escapeValue: false },
    fallbackLng: 'en',
    ns: [...NAMESPACES],
    backend: {
        loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    react: reactOptions,
    detection: {
        order: ['localStorage', 'cookie', 'navigator'],
        lookupLocalStorage: 'i18nlocale',
    },
};

/** No XHR backend or language detector — avoids dozens of open handles under Jest/jsdom. */
const testOptions: InitOptions = {
    interpolation: { escapeValue: false },
    fallbackLng: 'en',
    lng: 'en',
    ns: [...NAMESPACES],
    resources: emptyEnglishResources(),
    react: reactOptions,
};

const options = process.env.NODE_ENV !== 'test' ? prodOptions : testOptions;

// if (process.env.NODE_ENV === 'test') {
//     void i18n.use(initReactI18next).init(testOptions);
// } else {
void i18n.use(Backend).use(LanguageDetector).use(initReactI18next).init(options);
// }
i18n.on('languageChanged', (lng) => {
    moment.locale(lng);
});

export default i18n;
